import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "@/contexts/auth-context";

export type { AuthUser } from "@/contexts/auth-context";

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return ctx;
}
